import Logo from '../ui/Logo.jsx';

/**
 * Layout delle schermate di autenticazione (login, registrazione, recupero):
 * logo centrato sopra il riquadro, riquadro centrato nella viewport.
 *
 * @param {string} title     Titolo del riquadro
 * @param {string} subtitle  Sottotitolo opzionale
 * @param {*} children         Contenuto del riquadro (form / messaggi)
 * @param {*} footer           Righe opzionali sotto il riquadro (link incrociati)
 */
export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="auth-shell">
      <Logo />

      <section className="w-full max-w-md card-elevated p-6 space-y-4">
        <header className="text-center">
          <h1 className="text-xl font-semibold text-surface">{title}</h1>
          {subtitle && <p className="text-sm text-surface-4 mt-0.5">{subtitle}</p>}
        </header>
        {children}
      </section>

      {footer && <footer className="w-full max-w-md text-center text-sm text-surface-4">{footer}</footer>}
    </div>
  );
}
